import { useRef, useEffect } from "react";

export const CursorGlow = () => {
  const glowRef = useRef(null);

  useEffect(() => {
    const glow = glowRef.current;
    if (!glow) return;

    let isTouchDevice = false;

    const handleMouseMove = (e) => {
      if (isTouchDevice) return;
      glow.style.opacity = "1";
      glow.style.left = `${e.clientX}px`;
      glow.style.top = `${e.clientY}px`;
    };

    const handleMouseLeave = () => {
      glow.style.opacity = "0";
    };

    const handleTouchStart = () => {
      isTouchDevice = true;
      glow.style.display = "none";
    };

    document.addEventListener("mousemove", handleMouseMove, { passive: true });
    document.addEventListener("mouseleave", handleMouseLeave);
    document.addEventListener("touchstart", handleTouchStart, { once: true });

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseleave", handleMouseLeave);
      document.removeEventListener("touchstart", handleTouchStart);
    };
  }, []);

  return (
    <div
      ref={glowRef}
      className="fixed pointer-events-none z-[9999]"
      style={{
        opacity: 0,
        transform: "translate(-50%, -50%)",
        transition: "opacity 0.3s ease",
      }}
      aria-hidden="true"
      data-testid="global-cursor-glow"
    >
      <div
        className="absolute rounded-full"
        style={{
          width: "120px",
          height: "120px",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          background:
            "radial-gradient(circle, rgba(245, 134, 26, 0.18) 0%, rgba(245, 134, 26, 0) 70%)",
          filter: "blur(10px)",
        }}
      />
      <div
        className="absolute rounded-full"
        style={{
          width: "14px",
          height: "14px",
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          background:
            "radial-gradient(circle, rgba(255, 200, 100, 0.5) 0%, rgba(245, 134, 26, 0.25) 50%, transparent 100%)",
          boxShadow: "0 0 12px rgba(245, 134, 26, 0.35)",
        }}
      />
    </div>
  );
};
